import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  ViewChild,
} from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'arrow-scroll-box',
  styleUrls: ['./arrow-scroll-box.component.scss'],
  templateUrl: './arrow-scroll-box.component.html',
})
export class ArrowScrollBoxComponent implements AfterViewInit {
  canScrollLeft: boolean = false;
  canScrollRight: boolean = false;
  scrollDistance: number = 200;
  arrowSize: IconComponent.Size = 24;

  constructor(private readonly cdr: ChangeDetectorRef) {}
  @ViewChild('scrollable', { static: false }) scrollable: ElementRef;

  updateArrows() {
    if (this.scrollable) {
      const amountScrolledLeft: number =
        this.scrollable.nativeElement.scrollLeft;
      this.canScrollLeft = amountScrolledLeft > 0;
      this.canScrollRight =
        amountScrolledLeft + this.scrollable.nativeElement.clientWidth <
        this.scrollable.nativeElement.scrollWidth;
    }
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.updateArrows();
  }

  scrollRight() {
    const widthInsideArrows: number =
      this.scrollable.nativeElement.clientWidth - 3 * this.arrowSize;
    this.scrollable.nativeElement.scrollBy(
      Math.max(widthInsideArrows, this.arrowSize),
      0,
      'smooth',
    );
  }

  scrollLeft() {
    const widthInsideArrows: number =
      this.scrollable.nativeElement.clientWidth - 3 * this.arrowSize;
    this.scrollable.nativeElement.scrollBy(
      -Math.max(widthInsideArrows, this.arrowSize),
      0,
      'smooth',
    );
  }

  @HostListener('window:resize', ['$event'])
  windowResize() {
    this.updateArrows();
  }

  readonly onScroll = new EventEmitter();
}
